import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

const OlvideClave = () => {
  const [correo, setCorreo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setMensaje("");
    setError("");
    setLoading(true);

    try {
      const { data } = await api.post("/usuarios/olvide-clave", { correo });
      setMensaje(data?.mensaje || "Si el correo existe en el sistema, se envio un enlace para restablecer la clave.");
    } catch (err) {
      console.error("Error al solicitar recuperacion de clave:", err?.response?.data || err.message);
      setError(err.response?.data?.error || "No se pudo procesar la solicitud.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <p className="auth-card__eyebrow">Recuperacion de acceso</p>
        <h2 className="auth-card__title">Olvide mi clave</h2>
        <p className="auth-card__subtitle">
          Ingresa tu correo y te enviaremos un enlace para restablecer la contrasena.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Correo</label>
            <input
              type="email"
              className="form-control"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          {mensaje && <div className="alert alert-success">{mensaje}</div>}
          {error && <div className="alert alert-danger">{error}</div>}

          <button type="submit" className="btn btn-primary w-100 mt-2" disabled={loading}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>

        <div className="mt-3 text-center">
          <Link to="/">Volver al login</Link>
        </div>
      </div>
    </div>
  );
};

export default OlvideClave;
